import { useState, useEffect } from "react";
import { formatRelativeTime } from "../utils/relativeTime";

/**
 * Returns a live-updating Italian relative-time label for an instant.
 * Re-renders on an interval so "Adesso" → "1 minuto fa" → ... without reload.
 * @param {number} createdAt epoch ms
 * @param {number} [intervalMs] refresh cadence (default 30s)
 */
export function useRelativeTime(createdAt, intervalMs = 30_000) {
  const [label, setLabel] = useState(() => formatRelativeTime(createdAt));

  useEffect(() => {
    if (createdAt == null) return undefined;

    setLabel(formatRelativeTime(createdAt)); // immediate, on createdAt change
    const id = setInterval(
      () => setLabel(formatRelativeTime(createdAt)),
      intervalMs
    );
    return () => clearInterval(id);
  }, [createdAt, intervalMs]);

  return label;
}